<template>
  <div>
    <ContractForm
      :contract="contract"
      @clear="clearForm"
    />
    <Person26Text
      :contract="contract"
      :company="company"
      :companyObject="companyObject"
    />
  </div>
</template>

<script>
import viewsMixin from '@/mixins/views-mixin';
import ContractForm from '@/components/ContractForm.vue';
import Person26Text from '@/components/Person26Text.vue';

export default {
  name: 'Artist',
  components: {
    ContractForm,
    Person26Text,
  },
  mixins: [viewsMixin],
};
</script>
